// Track determination uses is_self_serve (NOT account.status, which is unused for business
// logic, see CLAUDE.md). is_self_serve=true is trial, false/undefined is paid.
// Tours never start on their own (EN-1289); users launch them from the "?" help menu.
import type { Account } from "@/common/utils/types";
import type { TourTrack } from "./types";

type TourAccountData = Pick<Account, "is_self_serve">;

export function getUserTrack(accountData: TourAccountData | null | undefined): TourTrack | null {
    if (!accountData) return null;
    return accountData.is_self_serve ? "trial" : "paid";
}
